module.exports = __webpack_public_path__ + "static/media/screenshot-6.ab6cc92d.png";